import getBasePath from '../functions/api-resource';

const basePath = getBasePath('api', 'bloqueio-sistema');

const bloqueioSistemaActions = {
  pesquisar: { method: 'GET', url: `${basePath}` },
};

export default (resource) => resource(`${basePath}`, {}, bloqueioSistemaActions);
